import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { MarkupTagChip } from "@pages/project-details/project-markups/markup-tags";
import { sortMarkupTags } from "@pages/project-details/project-markups/markup-tags-sort";
/** The tags of an annotation, sorted alphabetically. Chips speak for themselves, so no label */
export function MarkupSidePanelTags(t0) {
  const $ = _c(4);
  const {
    labels
  } = t0;
  let t1;
  let t2;
  if ($[0] !== labels) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const sortedTags = sortMarkupTags(labels);
      if (sortedTags.length === 0) {
        t2 = null;
        break bb0;
      }
      let t3;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
          gap: 1,
          flexDirection: "row",
          flexWrap: "wrap"
        };
        $[3] = t3;
      } else {
        t3 = $[3];
      }
      t1 = <Stack data-testid="markup-side-panel-tags-content" sx={t3}>{sortedTags.map(_temp)}</Stack>;
    }
    $[0] = labels;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
}
function _temp(tag) {
  return <MarkupTagChip key={tag.id} tag={tag} />;
}